// ----------------------------------------------------------------------
export function dialog(theme) {
    return {
        MuiDialog: {
            styleOverrides: {
                root: {
                    "& .MuiBackdrop-root": {
                        backdropFilter: "blur(10px)",
                        backgroundColor: "#00000033",
                    },
                },
                paper: ({ ownerState }) => ({
                    boxShadow: "0px 12px 24px -4px #919EAB1F",
                    borderRadius: theme.shape.borderRadius * 2,
                    backdropFilter: "blur(20px)",
                    ...(!ownerState.fullScreen && {
                        margin: theme.spacing(2),
                    }),
                }),
                paperFullScreen: {
                    borderRadius: 0,
                },
            },
        },
        MuiDialogTitle: {
            styleOverrides: {
                root: {
                    padding: theme.spacing(3),
                },
            },
        },
        MuiDialogContent: {
            styleOverrides: {
                root: {
                    padding: theme.spacing(0, 3),
                },
                dividers: {
                    borderTop: 0,
                    borderBottomStyle: "dashed",
                    paddingBottom: theme.spacing(3),
                },
            },
        },
        MuiDialogActions: {
            styleOverrides: {
                root: {
                    padding: theme.spacing(3),
                    "& > :not(:first-of-type)": {
                        marginLeft: theme.spacing(1.5),
                    },
                },
            },
        },
    };
}
